module.exports = '/ng-templates/commons/components/kp-new-documents/kp-new-documents.tpl.ftl';
